<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Alert } from '@Shelly/shelly-design-system/index';
	import { pending_connection_devices } from 'src/stores/device-runtime/firmware-ui';
	import { HALF_SLEEPING_TYPES, SLEEPING_TYPES } from 'src/constants';
	import type { Device } from 'src/types/Device';

	export let device: Device;
</script>

{#if !JSON.parse(sessionStorage.getItem('dissmised_sleeping_alerts'))?.includes(device.id) && $pending_connection_devices.includes(device.id) && (SLEEPING_TYPES.includes(device.type) || HALF_SLEEPING_TYPES.includes(device.type))}
	<Alert
		type="info"
		dismissable
		heading={$format('alert_heading_awaiting_first_connection', {
			default: 'Device Awaiting First Connection',
		})}
		isHeadingBold
		message={$format('alert_message_awaiting_first_connection', {
			default:
				'This device is in sleep mode and has not yet completed its first cloud connection. To activate it, press the device button to confirm and enable the initial connection.',
		})}
		on:dismissable_click={() => {
			if (!sessionStorage.getItem('dissmised_sleeping_alerts')) {
				sessionStorage.setItem('dissmised_sleeping_alerts', JSON.stringify([device.id]));
			} else {
				const dissmised_sleeping_alerts = JSON.parse(
					sessionStorage.getItem('dissmised_sleeping_alerts'),
				);
				if (!dissmised_sleeping_alerts.includes(device.id)) {
					sessionStorage.setItem(
						'dissmised_sleeping_alerts',
						JSON.stringify([...dissmised_sleeping_alerts, device.id]),
					);
				}
			}
		}}
	/>
{/if}
